module.exports = __webpack_public_path__ + "assets/media/kazan-slider-2.168e1570.jpg";